import * as types from '../types/searchTypes';
import * as searchServices from '../../services/searchServices';

// Search articles
export const searchArticles = (query, params = {}) => async (dispatch) => {
  dispatch({ type: types.SEARCH_ARTICLES_REQUEST });
  try {
    const response = await searchServices.searchArticles(query, params);
    dispatch({ 
      type: types.SEARCH_ARTICLES_SUCCESS, 
      payload: response.data || response 
    });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred while searching articles';
    dispatch({ type: types.SEARCH_ARTICLES_FAILURE, payload: errorMessage });
  }
};

// Search categories
export const searchCategories = (query) => async (dispatch) => {
  dispatch({ type: types.SEARCH_CATEGORIES_REQUEST });
  try {
    const response = await searchServices.searchCategories(query);
    dispatch({ 
      type: types.SEARCH_CATEGORIES_SUCCESS, 
      payload: response.data || response 
    });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred while searching categories';
    dispatch({ type: types.SEARCH_CATEGORIES_FAILURE, payload: errorMessage });
  }
};

// Search authors
export const searchAuthors = (query) => async (dispatch) => {
  dispatch({ type: types.SEARCH_AUTHORS_REQUEST });
  try {
    const response = await searchServices.searchAuthors(query);
    dispatch({ 
      type: types.SEARCH_AUTHORS_SUCCESS, 
      payload: response.data || response 
    });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred while searching authors';
    dispatch({ type: types.SEARCH_AUTHORS_FAILURE, payload: errorMessage });
  }
};

// Global search
export const globalSearch = (query) => async (dispatch) => {
  dispatch({ type: types.GLOBAL_SEARCH_REQUEST });
  try {
    const response = await searchServices.globalSearch(query);
    dispatch({ 
      type: types.GLOBAL_SEARCH_SUCCESS, 
      payload: response.data || response 
    });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred while performing global search';
    dispatch({ type: types.GLOBAL_SEARCH_FAILURE, payload: errorMessage });
  }
};

// Clear search results
export const clearSearchResults = () => (dispatch) => {
  dispatch({ type: types.CLEAR_SEARCH_RESULTS });
};


